var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-erros-box',{attrs:{"erros":_vm.erros}})
}
var staticRenderFns = []

export { render, staticRenderFns }